import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import GrowWithTrees from "components/GrowWithTrees";
import Login from "components/Login";
import ResetPassword from "components/ResetPassword";
import ConfirmResetPassword from "components/ConfirmResetPassword";
import NewPassword from "components/NewPassword";

const Public = () => {
  return (
    <>
      <Switch>
        <Route exact path="/login">
          <Login />
        </Route>
        <Route exact path="/resetpassword">
          <ResetPassword />
        </Route>
        <Route exact path="/confirm-reset">
          <ConfirmResetPassword />
        </Route>
        <Route exact path="/new-password">
          <NewPassword />
        </Route>
        <Route exact path="/error">
          <GrowWithTrees />
        </Route>
        <Redirect to="/login" />
      </Switch>
    </>
  );
};

export default Public;
